import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'MailChimp';

  ngOnInit(): void {
    this.overrideDateToJsonFunction();
  }

  private overrideDateToJsonFunction(): void {
    Date.prototype.toJSON = function () {
      return new Date(this.getTime() - this.getTimezoneOffset() * 60 * 1000).toISOString();
    };
  }
}
